import { render, staticRenderFns } from "./ManageTask.vue?vue&type=template&id=72c5c460&scoped=true"
import script from "./ManageTask.vue?vue&type=script&lang=js"
export * from "./ManageTask.vue?vue&type=script&lang=js"
import style0 from "./ManageTask.vue?vue&type=style&index=0&id=72c5c460&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72c5c460",
  null
  
)

export default component.exports